import { onDomReady } from "./helpers";

// Add class to 'a' elements when url ends with extension.
const contactsContent = document.querySelector('.contacts-content');
if (contactsContent) {
    contactsContent.querySelectorAll('a').forEach((a) => {
        if (a.hasAttribute('href')) {
            const src = a.getAttribute('href');
            const extension = src.split('/[#?]/')[0].split('.').pop().trim();
            if (extension === "pdf") {
                a.classList.add("pdf-file");
            }
        }
    });
}

// Submit filter form when option is selected
onDomReady( () => {
    const selectElements = document.querySelectorAll('.filter form select');

    selectElements.forEach( selectElement => {
        selectElement.addEventListener( 'change', function () {
            this.form.submit();
        } );
    } );
} );
